import React, { useEffect, useState, useRef } from "react";
import "../Map/Map.css";
import Mapir from "mapir-react-component";
import { search } from "../../Components/Map/API";

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ",
        "Mapir-SDK": "reactjs",
      },
    };
  },
});
export default function MapHandler(props) {
  const [text, setText] = useState("");
  const [polygon, setPolygon] = useState();
  const [zoom, setZoom] = useState(13);
  const [lon, setLon] = useState(null);
  const [lat, setLat] = useState(null);
  const [$select, set$select] = useState("poi,city,roads,neighborhood");
  const [$filter, set$filter] = useState("province eq بهشهر");
  const [showAdvancedSettings] = useState(false);
  const [results, setResults] = useState([]);
  const [showSearch, setShowSearch] = useState(true);
  const [marker] = useState(null);
  const [center, setCenter] = useState([53.54347, 36.69056]);
  const [nearby, setNearby] = useState({
    active: false,
    coordinates: null,
  });
  const filterTypeRef = useRef();
  const drawControl = useRef();
  const filterRefVal = useRef();
  useEffect(() => {
    if (text.length > 1) {
      const params = {};
      const options = { text, polygon, lon, lat, $select, $filter };
      for (let key in options) {
        if (options[key] !== null && options[key] !== "") {
          params[key] = options[key];
        }
      }
      search(params)
        .then((data) => data.json())
        .then((data) => {
          if (data["odata.count"] > 0) {
            setResults(data.value);
          } else {
            setResults([{ notFound: true }]);
          }
        });
    } else if (text.length === 0) {
      setResults([]);
    }
    setText(props.text);
    setPolygon(props.polygon);
    setCenter(props.center);
    if (text === "") {
      setShowSearch(true);
    }
  }, [
    text,
    $select,
    $filter,
    nearby.coordinates,
    props.text,
    lat,
    lon,
    polygon,
    props.polygon,
    props.center,
  ]);

  function mapClickHandler(map, e) {
    setCenter([e.lngLat.lng, e.lngLat.lat]);
    setTimeout(() => {
      setZoom(15);
    }, 1000);
    localStorage.setItem("checkMarker", true);
    reverseFunction(map, e);
    if (nearby.active) {
      setNearby({
        ...nearby,
        coordinates: [e.lngLat.lng, e.lngLat.lat],
      });
      setLon(e.lngLat.lng);
      setLat(e.lngLat.lat);
      let s = $select;
      if (!$select.includes("nearby")) {
        let sa = $select.split(",");
        sa.push("nearby");
        s = sa.filter((item) => item !== "").join(",");
      }
      set$select(s);
    }
  }
  useEffect(() => {
    if (polygon === "") {
      drawControl.current.draw.changeMode("draw_polygon");
    } else if (polygon instanceof Object) {
      set$filter("polygon eq true");
    } else if (polygon === null) {
      set$filter("");
    }
  }, [polygon]);
  const [markerArray, setMarkerArray] = useState([]);
  function reverseFunction(map, e) {
    var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem("lon", data.geom.coordinates[1]);
        localStorage.setItem("lat", data.geom.coordinates[0]);
        localStorage.setItem("address_compact", data.address_compact);
      });
    const array = [];
    array.push(
      <Mapir.Marker
        coordinates={[e.lngLat.lng, e.lngLat.lat]}
        anchor="bottom"
        Image={"/Assets/Images/map/marker1.png"}
        key={0}
      />
    );
    // setCenter([e.lngLat.lng, e.lngLat.lat])
    // setZoom(16)
    setMarkerArray(array);
  }
  ////////////////click search result ///////////////
  function searchOnclick(item) {
    const array = [];
    array.push(
      <Mapir.Marker
        coordinates={[item.geom.coordinates[0], item.geom.coordinates[1]]}
        Image={"/Assets/Images/map/marker1.png"}
        key={0}
      />
    );

    setMarkerArray(array);
    props.parentCallback(item.address);
    setShowSearch(false);
    setCenter([item.geom.coordinates[0], item.geom.coordinates[1]]);
  }
  return (
    <>
      <div className="App">
        <Mapir
          onClick={(map, e) => mapClickHandler(map, e)}
          center={center}
          zoom={[zoom]}
          Map={Map}
          userLocation
        >
          {markerArray}
          {/* {marker !== null && (
            <Mapir.Marker
              coordinates={[marker.lng, marker.lat]}
              anchor="bottom" 
              key={0}
            />
          )}
          {nearby.active && nearby.coordinates !== null && (
            <Mapir.Marker
              coordinates={[nearby.coordinates[0], nearby.coordinates[1]]}
              anchor="bottom"
              key={0}
            />
          )} */}
        </Mapir>
      {showSearch ? (
        <div className="container search-box bg-transparent">
          <div
            className="container search-box__item"
            style={{ display: "none" }}
          >
            <input
              autoComplete="off"
              type="text"
              id="search"
              placeholder="دنبال کجا می&zwnj;گردید..."
              onChange={(e) => setText(e.target.value)}
              value={text}
            />
          </div>
          {results.length > 0 && (
            <div className="container search-box__item search-results">
              {results.map((item, index) => {
                if (item.notFound === true) {
                  return <p>نتیجه ای یافت نشد</p>;
                } else {
                  return (
                    <div
                      key={index}
                      onClick={() => searchOnclick(item)}
                      className="search-result-item"
                    >
                      <p className="search-result-item-title">{item.title}</p>
                      <p className="search-result-item-address">
                        {item.address}
                      </p>
                    </div>
                  );
                }
              })}
            </div>
          )}
        </div>
      ) : null}
      </div>
    </>
  );
}
